import React from 'react';
export default (props) => {
    const { iconName, className } = props;
    return (<span className={`icon icon--${iconName} ${className ? className : ''}`}>
      <img className="icon__image" src={`/assets/wza/img/content/${iconName}.svg`}/>
    </span>);
};
